import { NgModule } from '@angular/core';
import { AmdInputContainerComponent } from '../input-container/input-container.component';
var AmdInputContainerModule = /** @class */ (function () {
    function AmdInputContainerModule() {
    }
    AmdInputContainerModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AmdInputContainerComponent],
                    exports: [AmdInputContainerComponent]
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdInputContainerModule.ctorParameters = function () { return []; };
    return AmdInputContainerModule;
}());
export { AmdInputContainerModule };
function AmdInputContainerModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdInputContainerModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdInputContainerModule.ctorParameters;
}
//# sourceMappingURL=input-container.module.js.map
//# sourceMappingURL=input-container.module.js.map
